import { definePermission } from "./permission";
/**
 * Maintenance operations (`D52`): the manually triggered sweeps and purges.
 *
 * One name, deliberately. Splitting it per operation would put a catalogue
 * entry in front of every future script, and `D52`'s rule is that a catalogue
 * entry nothing gates is the same class of thing as the `scopes` claim `D56`
 * deletes.
 */
export const MAINTENANCE_RUN = definePermission("maintenance:run", "Run maintenance operations, such as retry sweeps and purges.");
export const MAINTENANCE_PERMISSIONS = [MAINTENANCE_RUN];
//# sourceMappingURL=maintenance.js.map